"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _member = require("@/api/member");
var _permission = require("@/utils/permission");
var _index = _interopRequireDefault(require("@/components/ButtonTimePicker/index"));
var _index2 = _interopRequireDefault(require("@/components/StatisticsDataCardList/index"));
var _pieChart = _interopRequireDefault(require("@/components/echartsNew/pieChart"));
var _lineBarChart = _interopRequireDefault(require("@/components/echartsNew/lineBarChart"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'index',
  components: {
    ButtonTimePicker: _index.default,
    StatisticsDataCardList: _index2.default,
    PieChart: _pieChart.default,
    LineBarChart: _lineBarChart.default
  },
  data: function data() {
    return {
      startTime: '',
      // 开始时间
      endTime: '',
      // 结束时间
      memberStatisticsDataList: [],
      // 会员统计数据
      memberNum: 0,
      // 现有会员总数
      memberLevelMap: {},
      // 	会员等级分布数据
      memberSourceMap: {},
      // 会员来源渠道分布数据
      newMemberXData: [],
      // 会员新增趋势x轴数据
      newMemberYData: {},
      // 会员新增趋势y轴数据
      consumeXData: [],
      // 会员消费趋势x轴数据
      consumeYData: {},
      // 会员消费趋势y轴数据
      // 新增会员趋势图图例配置
      newMemberLegend: {
        orient: 'horizontal',
        top: 'bottom',
        left: 'center',
        data: [{
          name: '新增会员人数',
          icon: 'rect'
        }, {
          name: '充值人数',
          icon: 'rect'
        }]
      },
      // 会员消费趋势图图例配置
      consumeLegend: {
        orient: 'horizontal',
        top: 'bottom',
        left: 'center',
        data: [{
          name: '下单数量',
          icon: 'circle'
        }, {
          name: '消费金额',
          icon: 'rect'
        }]
      },
      // 会员消费趋势图颜色列表
      consumeColorList: [{
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0,
          color: '#8181FF' // 条形顶部的颜色
        }, {
          offset: 1,
          color: '#E5E5FF' // 条形底部的颜色
        }]
      }, '#fa8c16']
    };
  },
  computed: {},
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:member:level:distribution'])) {
      // this.getLevelDistribution();
    }
    // 获取会员概览数据
    this.getMemberOverviewData();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 获取会员环比数据
    getMemberStatisticsMomData: function getMemberStatisticsMomData() {
      var _this = this;
      var param = {
        dateLimit: this.startTime + ',' + this.endTime
      };
      (0, _member.getMemberStatisticsMomDataApi)(param).then(function (res) {
        var statisticData = [{
          name: '现有会员总数',
          value: _this.memberNum,
          isCumulativeData: true
        }, {
          name: '新增会员数',
          value: res.newNum,
          growthRate: res.newNumMom,
          increased: parseFloat(res.newNumMom.replace('%', '')) > 0
        }, {
          name: '充值金额(元)',
          value: res.rechargeAmount,
          growthRate: res.rechargeAmountMom,
          increased: parseFloat(res.rechargeAmountMom.replace('%', '')) > 0
        }, {
          name: '充值订单数',
          value: res.rechargeOrderNum,
          growthRate: res.rechargeOrderNumMom,
          increased: parseFloat(res.rechargeOrderNumMom.replace('%', '')) > 0
        }, {
          name: '会员消费金额(元)',
          value: res.consumeAmount,
          growthRate: res.consumeAmountMom,
          increased: parseFloat(res.consumeAmountMom.replace('%', '')) > 0
        }, {
          name: '会员消费订单数',
          value: res.consumeOrderNum,
          growthRate: res.consumeOrderNumMom,
          increased: parseFloat(res.consumeOrderNumMom.replace('%', '')) > 0
        }, {
          name: '消费会员人数',
          value: res.consumeMemberNum || 0,
          growthRate: res.consumeMemberNumMom || 0,
          increased: res.consumeMemberNumMom ? parseFloat(res.consumeMemberNumMom.replace('%', '')) > 0 : false
        }, {
          name: '活跃会员人数',
          value: res.activeMemberAmount || 0,
          growthRate: res.activeMemberAmountMom || 0,
          increased: res.consumeMemberNumMom ? parseFloat(res.activeMemberAmountMom.replace('%', '')) > 0 : false
        }];
        _this.$set(_this, 'memberStatisticsDataList', JSON.parse(JSON.stringify(statisticData)));
      }).catch(function (err) {
        _this.Message.error(err.msg);
      });
    },
    // 获取会员概览数据
    getMemberOverviewData: function getMemberOverviewData() {
      var _this2 = this;
      (0, _member.getMemberOverviewDataApi)().then(function (res) {
        _this2.memberNum = res.memberNum;
        // 如果先调用了获取会员环比数据的接口，则对现有会员总数进行重新赋值
        if (_this2.memberStatisticsDataList[0]) {
          _this2.memberStatisticsDataList[0].value = res.memberNum;
        }
        _this2.memberLevelMap = res.memberLevelMap;
        _this2.memberSourceMap = res.memberSourceMap;
      }).catch(function (err) {
        _this2.Message.error(err.msg);
      });
    },
    // 获取会员新增趋势数据
    getMemberNewTrendData: function getMemberNewTrendData() {
      var _this3 = this;
      var param = {
        dateLimit: this.startTime + ',' + this.endTime
      };
      (0, _member.getMemberNewTrendDataApi)(param).then(function (res) {
        var xAxis = [],
          yData = {
            新增会员人数: [],
            充值人数: []
          };
        res.forEach(function (item, index) {
          xAxis.push(item.date);
          yData['新增会员人数'].push(item.newNum);
          yData['充值人数'].push(item.rechargeNum);
        });
        _this3.newMemberXData = xAxis;
        _this3.newMemberYData = yData;
      }).catch(function (err) {
        _this3.Message.error(err.msg);
      });
    },
    // 获取会员消费趋势数据
    getMemberConsumeTrendData: function getMemberConsumeTrendData() {
      var _this4 = this;
      var param = {
        dateLimit: this.startTime + ',' + this.endTime
      };
      (0, _member.getMemberConsumeTrendDataApi)(param).then(function (res) {
        var xAxis = [],
          yData = {
            下单数量: [],
            消费金额: []
          };
        res.forEach(function (item, index) {
          xAxis.push(item.date);
          yData['下单数量'].push(item.orderNum);
          yData['消费金额'].push(item.consumeAmount);
        });
        _this4.consumeXData = xAxis;
        _this4.consumeYData = yData;
      }).catch(function (err) {
        _this4.Message.error(err.msg);
      });
    },
    // 日期范围更改
    dateRangeChange: function dateRangeChange(timeVal) {
      this.startTime = timeVal[0];
      this.endTime = timeVal[1];
      // 获取会员环比数据
      this.getMemberStatisticsMomData();
      // 获取会员新增趋势数据
      this.getMemberNewTrendData();
      // 获取会员消费趋势数据
      this.getMemberConsumeTrendData();
    }
  }
};